import React, {  useState,useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";
import { Input } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import {

  Textarea

} from "@chakra-ui/react";



import "./childModal.css"
import "./childModalDark.css"

import CommentBox from "../commentBox/commentBox";
import Status from "../status/status";

import Metka from "../metka/metka";

import Perfomer from "../perfomer/perfomer";
import UploadFileTaskMenegerChild from "../uploadFile/uploadFileChild";
import CommentBoxCreatTask from "../commentCreatTask/commentCreatTask";
import Prioritet from "../prioritet/prioritet";
import { useSelector } from "react-redux";




function ChilMNodal({ item ,allaray,nameCurrentSubTask,sendServer,setperfomerID,setchildPerfomer,handleClose,deleteItemByIndex,index,metkas,load}) {




  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const handleCloseChild = () => setShow(false);
  const handleShow = () => setShow(true);
  const [comments, setComments] = useState([]);
  const [templates, satTemplates] = useState("");
  const [taskName, satTtaskName] = useState("");
  const [templatesArray, satTemplatesArray] = useState([]);
  const currentDate = new Date();
  const adjustedDate = new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000);
  const formattedDate = adjustedDate.toISOString().slice(0, 16);
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState(formattedDate);
  const [status, setStatus] = useState("");
  const [prioritet, setPrioritet] = useState("Низший");
  const [metka, setMetka] = useState([]);
  const [performer, setperformer] = useState("");
  const [aboutTask, setAboutTask] = useState("");
  const [file, setfile] = useState(null);
  const modalRef = useRef(null)
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
  
// получить элемент и установить состояние
  useEffect(()=>{
      item.comments = comments
      item.performer = performer
      item.startDate = startDate
      item.endDate = endDate
      item.status = status
      item.prioritet = prioritet
      item.aboutTask = aboutTask
      item.performer = performer
      item.file = file
  },[comments,performer,templates,templatesArray,startDate,endDate,status,prioritet,metka,taskName,aboutTask,file])

// добавить исполнителя

useEffect(()=>{
      
        
        if (performer == "") {
          setperformer(allaray[0].perfomerID[0])
        }
},[allaray])

  const HandleSetPerfomerId=(e)=>{
    setperfomerID([setperformer])
    setperformer(e)
      setchildPerfomer(performer)
      
     
  }
// удалить исполнителя
  const HandleDeletePerfomerId=(e)=>{

    setperformer("")
    setperfomerID([])
  }
// отправить дочерний сервер
const senderServerChild=()=>{
  sendServer(allaray,metkas)


}
// изменить файл
const handleChangeFile=(e)=>{
  setfile(e)
}

useEffect(()=>{
  modalRef.current.style.display = "none"
},[])

const handleShowChildModal=()=>{
  modalRef.current.style.display = "flex"
}


const handleCloseChildModal=()=>{
  modalRef.current.style.display = "none"
}


  return (
    <div className="modalCreatTaskChild" >
        <div className="modalDateAndInfiOut">
              <div className="taskNameDateInfo">
              <h6>#{index+1}</h6>
            <p className="TaskNameShow">{item.msg}</p>
        <p className="endDateChild">{endDate.split("T").join(",")}</p>
              </div>
              <div className="statusPrioritetChild">
                  <div>
                      <Prioritet setPrioritet={setPrioritet} prioritet={prioritet}/>
                      
                      
                      {(() => {
  let findWorkerID = gerChekcedCompany.rootReducer?.users?.data.find(findWorkerById => findWorkerById.workerID == item?.performer?.workerID );

  if (findWorkerID) {
    return <Avatar name={findWorkerID.name ? findWorkerID.name : ""} src={findWorkerID.img} size={"sm"} />;
  } else {
    // You might want to return something in case findWorkerID is not truthy.
    // You can return null or an empty fragment as a placeholder.
    return null;
  }
})()}


                   
                    <Status setStatus={setStatus} status={status}/>  
                  </div>
                  <div className="smollItem">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" onClick={handleShowChildModal} className="editSvgSubTask">
            <path d="M7.54953 4.2742L8.17752 4.9274L1.99318 11.36H1.3652V10.7068L7.54953 4.2742ZM10.0069 0C9.83623 0 9.65876 0.071 9.52906 0.2059L8.27991 1.5052L10.8396 4.1677L12.0888 2.8684C12.355 2.5915 12.355 2.1442 12.0888 1.8673L10.4915 0.2059C10.355 0.0639 10.1844 0 10.0069 0ZM7.54953 2.2649L0 10.1175V12.78H2.55974L10.1093 4.9274L7.54953 2.2649Z" fill="#3B79F6"/>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" className="copyLinkSubTask">
            <path d="M9.59222 8.13283C9.22676 8.13369 8.86669 8.22096 8.54141 8.38754C8.21613 8.55412 7.93486 8.79527 7.72057 9.09131L4.80738 7.14938C4.99096 6.65987 4.99096 6.12042 4.80738 5.63092L7.72057 3.68898C8.04755 4.13228 8.5219 4.44445 9.05839 4.5694C9.59488 4.69435 10.1583 4.6239 10.6475 4.3707C11.1367 4.11749 11.5196 3.69813 11.7274 3.18797C11.9352 2.67781 11.9542 2.11027 11.7811 1.58734C11.6079 1.0644 11.254 0.620345 10.7829 0.334942C10.3117 0.0495394 9.75423 -0.0584985 9.21058 0.030239C8.66692 0.118976 8.17273 0.398672 7.81679 0.819076C7.46085 1.23948 7.26649 1.77303 7.26863 2.32388C7.2724 2.40852 7.28093 2.49288 7.29419 2.57657L4.16258 4.66431C3.82885 4.36345 3.41505 4.16582 2.97129 4.09533C2.52753 4.02485 2.07285 4.08453 1.66233 4.26717C1.2518 4.4498 0.903026 4.74755 0.658252 5.12434C0.413479 5.50114 0.283203 5.94082 0.283203 6.39015C0.283203 6.83947 0.413479 7.27915 0.658252 7.65595C0.903026 8.03274 1.2518 8.33049 1.66233 8.51312C2.07285 8.69576 2.52753 8.75545 2.97129 8.68496C3.41505 8.61448 3.82885 8.41684 4.16258 8.11599L7.29419 10.2037C7.28093 10.2874 7.2724 10.3718 7.26863 10.4564C7.26863 10.916 7.40491 11.3652 7.66023 11.7473C7.91555 12.1294 8.27844 12.4273 8.70302 12.6031C9.1276 12.779 9.59479 12.825 10.0455 12.7354C10.4963 12.6457 10.9103 12.4244 11.2352 12.0994C11.5602 11.7745 11.7815 11.3605 11.8712 10.9097C11.9608 10.459 11.9148 9.9918 11.7389 9.56722C11.5631 9.14264 11.2652 8.77975 10.8831 8.52443C10.501 8.26911 10.0518 8.13283 9.59222 8.13283Z" fill="#6B7A99"/>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" className="deletSubTASK"  onClick={()=> deleteItemByIndex(index)}>
            <path d="M3.08594 13.2509C2.73145 13.2509 2.42798 13.1466 2.17554 12.9379C1.9231 12.7293 1.79688 12.4785 1.79688 12.1855V2.06481H0.916016V0.999467H4.95508V0.466797H10.627V0.999467H14.666V2.06481H13.7852V12.1855C13.7852 12.4696 13.6562 12.7182 13.3984 12.9313C13.1406 13.1444 12.8398 13.2509 12.4961 13.2509H3.08594ZM12.4961 2.06481H3.08594V12.1855H12.4961V2.06481ZM5.36328 10.6586H6.65234V3.57404H5.36328V10.6586ZM8.92969 10.6586H10.2187V3.57404H8.92969V10.6586Z" fill="#E62E7B"/>
          </svg>
                </div>
              </div>
          
        </div>


<div id="myModal" class="modalChildModal" ref={modalRef}>


<div class="modal-contentChildModal">
  <div class="modal-headerChildModal">
    <span class="closeChildModal" onClick={handleCloseChildModal}>&times;</span>
   
  </div>
  <div class="modal-bodyChildModal">
  <div className="perfomerAndShef">
      <div>
      <Perfomer  setperfomerID={setperfomerID} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} bydefault={performer}/>
      </div>
      <div className="StatusPrioritetCont">
      <Status setStatus={setStatus} status={status}/>
          <Prioritet setPrioritet={setPrioritet} prioritet={prioritet}/>
      </div>
      
  </div>

  <div className="inputCreatTask">
         
        <div className="taskinputsDiv">
        <Metka setMetka={setMetka} metka={metka}/>
        <p>Название подзадачи</p>


        <input className="currentTaskName" value={nameCurrentSubTask} disabled/>
             
              <div style={{margin: "30px 0px"}}>
              <p className="srok">Сроки</p>
              <div className="date">
                <label htmlFor="" className="startDate">
                  <p>Дата начала:</p>
                  <Input
                    size="sm"
                    type="datetime-local"
                    colorScheme="grey"
                    defaultValue={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                   
                  />
                </label>
                <label htmlFor="">
                 <p>Дата конца:</p>
                  <Input
                    size="sm"
                    type="datetime-local"
                    defaultValue={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </label>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M9.5 20H2.5C1.39 20 0.5 19.1 0.5 18L0.51 4C0.51 2.9 1.39 2 2.5 2H3.5V1C3.5 0.45 3.95 0 4.5 0C5.05 0 5.5 0.45 5.5 1V2H13.5V1C13.5 0.45 13.95 0 14.5 0C15.05 0 15.5 0.45 15.5 1V2H16.5C17.6 2 18.5 2.9 18.5 4V10H16.5V8H2.5V18H9.5V20ZM19.63 14.99L20.34 14.28C20.73 13.89 20.73 13.26 20.34 12.87L19.63 12.16C19.24 11.77 18.61 11.77 18.22 12.16L17.51 12.87L19.63 14.99ZM18.92 15.7L13.91 20.71C13.73 20.89 13.47 21 13.21 21H12C11.72 21 11.5 20.78 11.5 20.5V19.29C11.5 19.02 11.61 18.77 11.79 18.58L16.8 13.57L18.92 15.7Z" fill="#3B79F6"/>
</svg>
              </div>
              </div>
            
              <p className="taskDeskriptionText">Добавьте описание задачи</p>
               <textarea placeholder='Добавьте  описание подзадачи' className="taskDeskription" onChange={(e) => setAboutTask(e.target.value)}/>
         
            {/* загрузить файл дочернего компонента */}
          <UploadFileTaskMenegerChild setfile={setfile} file={file} handleChangeFile={handleChangeFile}/>
          {/* компонент комментария */}
          
        </div>

        <div className="taskinputsDiv2">
        <CommentBoxCreatTask setComments={setComments}comments={comments}/>
          {/* Компонент исполнителя */}
       
           
          {/* компонент состояния */}
       
         {/* Приоритетный компонент */}
      
            {/* метка компонент */}
          
        </div>
      </div>
  </div>
  <div class="modal-footerChildModal">
  <button variant="secondary" onClick={handleCloseChildModal}>
            Закрыть
          </button>

          {
            load?
            <button  >
            Loading...
          </button>
            :
            <button  onClick={senderServerChild}>
            Создать задачу
          </button>
          }
         
  </div>
</div>

</div>
      
      
    </div>
  );
}

export default ChilMNodal;
